import { Loader } from "@googlemaps/js-api-loader"
import { TextField } from "@material-ui/core"
import { useContext, useEffect, useMemo, useRef } from "react"
import useParametros from "../../contexts/ParametrosContext"
import SiteContext from "../../contexts/SiteContext"
import { RegistrarLogErro } from "../../services/functions"

export default function GoogleMapsAutocompleteInput({
    autoFocus = false,
    fullWidth = false,
    mapElement,
    setEnderecoCadastrado = () => {},
    setCepFoiCadastrado = () => {},
    setAbrirNovoEndereco,
    setLoading,
    alertStart,
    ComumCep,
}) {
    const { estabelecimentoAtual, aplicativoDados } = useContext(SiteContext)

    const parametros = useParametros()

    const listenerRef = useRef(null)
    const placeRef = useRef(null)

    const checarCepGoogleMaps = async endereco => {
        try {
            let valorCep = endereco.address_components
                .find(addressComponent => addressComponent.types.includes("postal_code"))
                ?.long_name.replace(/-/g, "")
                .replace(/ /g, "")
                .replace(/\//g, "")

            if (valorCep?.length === 8) {
                setLoading(true)
                const response = await ComumCep(valorCep, aplicativoDados)

                if (response.retornoErro) {
                    setLoading(false)
                    alertStart(response.mensagem, "error")
                    return
                }

                if (response.bairroEspecifico || response.bairros?.length >= 1) {
                    setEnderecoCadastrado({
                        ...response,
                        bairroEspecifico: true,
                        cep: valorCep,
                        logradouro: endereco.address_components.find(addressComponent =>
                            addressComponent.types.includes("route")
                        )?.long_name,
                        numero: endereco.address_components.find(addressComponent =>
                            addressComponent.types.includes("street_number")
                        )?.long_name,
                        localidade: endereco.address_components.find(addressComponent =>
                            addressComponent.types.includes("administrative_area_level_2")
                        )?.long_name,
                        uf: endereco.address_components.find(addressComponent =>
                            addressComponent.types.includes("administrative_area_level_1")
                        )?.short_name,
                    })
                } else if (response.id || response.logradouro) {
                    // setCepFoiCadastrado(true)
                    response.numero = endereco.address_components.find(addressComponent =>
                        addressComponent.types.includes("street_number")
                    )?.long_name
                    setEnderecoCadastrado({ ...response, bairroEspecifico: false })
                } else {
                    alertStart("Não foi possível identificar seu CEP", "error")
                }
            } else {
                console.log("asdasd NÃO TEM CEP", endereco)
                setEnderecoCadastrado({
                    logradouro: endereco.address_components.find(addressComponent =>
                        addressComponent.types.includes("route")
                    )?.long_name,
                    numero: endereco.address_components.find(addressComponent =>
                        addressComponent.types.includes("street_number")
                    )?.long_name,
                    bairro: endereco.address_components.find(addressComponent =>
                        addressComponent.types.includes("sublocality_level_1")
                    )?.long_name,
                    localidade: endereco.address_components.find(addressComponent =>
                        addressComponent.types.includes("administrative_area_level_2")
                    )?.long_name,
                    uf: endereco.address_components.find(addressComponent =>
                        addressComponent.types.includes("administrative_area_level_1")
                    )?.short_name,
                    bairroEspecifico: aplicativoDados.tipoEntregaBairro === 1,
                    cep: valorCep,
                })
            }
            setAbrirNovoEndereco(true)
            setLoading(false)
        } catch (error) {
            RegistrarLogErro(error, "checarCepGoogleMaps", endereco)
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
            setLoading(false)
        }
    }

    const loader = useMemo(
        () =>
            new Loader({
                apiKey: "AIzaSyAr6pWr6cj7IZ931BnL84KgCiYinmmf35A",
                version: "beta",
                libraries: ["places"],
            }),
        []
    )

    useEffect(() => {
        loader.load().then(google => {
            let inputBox

            const temCoordenada =
                Number(estabelecimentoAtual?.latitude) && Number(estabelecimentoAtual?.longitude)

            const mapCenter = temCoordenada
                ? {
                      lat: Number(estabelecimentoAtual.latitude),
                      lng: Number(estabelecimentoAtual.longitude),
                  }
                : { lat: -12.720151, lng: -50.43879 }

            google.maps.importLibrary("places").then(teste => {
                const input = document.getElementById("search-input")

                const codigoPais = parametros.PUBLIC_CODIGO_PAIS ?? "br"

                const options = {
                    bounds: temCoordenada
                        ? {
                              north: mapCenter.lat + 0.2,
                              south: mapCenter.lat - 0.2,
                              east: mapCenter.lng + 0.2,
                              west: mapCenter.lng - 0.2,
                          }
                        : { east: 180, west: -180, north: 90, south: -90 }, // Todo o mapa
                    strictBounds: false, // Limita os resultados para dentro de bounds. Se desativado somente dá preferência para eles.
                    fields: ["formatted_address", "geometry", "address_components"],
                    componentRestrictions: { country: codigoPais },
                }

                inputBox = new teste.Autocomplete(input, options)

                const handleAdressSelection = () => {
                    placeRef.current = inputBox.getPlace()
                    console.log("asdasd place", placeRef.current)

                    if (!placeRef.current.geometry) return

                    if (mapElement) {
                        if (placeRef.current.geometry.viewport) {
                            mapElement.fitBounds(placeRef.current.geometry.viewport)
                        } else {
                            mapElement.setCenter(placeRef.current.geometry.location)
                            mapElement.setZoom(16)
                        }
                    }

                    input.value = ""
                    checarCepGoogleMaps(placeRef.current)
                    setAbrirNovoEndereco(true)
                }

                listenerRef.current = inputBox.addListener("place_changed", handleAdressSelection)
            })
        })

        return () => listenerRef.current?.remove() // Não funciona com StrictMode
    }, [])

    return (
        <TextField
            id="search-input"
            autoFocus={autoFocus}
            type="text"
            fullWidth={fullWidth}
            variant="outlined"
            size="small"
        />
    )
}
